
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/UserDocs/AdvancedTopics/Rules",
      function () {
        return require("private-next-pages/docs/UserDocs/AdvancedTopics/Rules.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/UserDocs/AdvancedTopics/Rules"])
      });
    }
  